export default "__VITE_ASSET__f988ac5d__"